// Contenu juridique — français. Source de vérité, verbatim.
import termsFr from "./termsFr";

export default {
  terms: termsFr,
  privacy: {
    lastUpdatedLabel: "Dernière mise à jour",
    sections: [
      {
        id: "data-collected",
        heading: "1. Données collectées",
        paragraphs: [
          "Nous collectons les informations de compte (nom, email), les données de votre pratique que vous saisissez, et des données techniques (logs, cookies de session) nécessaires au fonctionnement.",
        ],
      },
      {
        id: "use",
        heading: "2. Utilisation",
        paragraphs: [
          "Vos données servent à fournir et améliorer le service, traiter les paiements et assurer la sécurité. Nous ne vendons pas vos données.",
        ],
      },
      {
        id: "clients-data",
        heading: "3. Données de vos clients",
        paragraphs: [
          "Vous êtes responsable du traitement des données de vos propres clients. Solunary agit comme sous-traitant et applique des mesures de sécurité raisonnables.",
        ],
      },
      {
        id: "sharing",
        heading: "4. Partage",
        paragraphs: [
          "Nous partageons des données uniquement avec des sous-traitants nécessaires (hébergement, paiements via Stripe, emails via Resend) et lorsque la loi l'exige.",
        ],
      },
      {
        id: "retention-rights",
        heading: "5. Conservation & droits",
        paragraphs: [
          "Vous pouvez accéder, corriger ou supprimer vos données depuis vos paramètres ou en nous contactant. Les données sont conservées le temps nécessaire au service.",
        ],
      },
      {
        id: "security",
        heading: "6. Sécurité",
        paragraphs: [
          "Nous appliquons le chiffrement en transit et des contrôles d'accès. Aucun système n'est infaillible ; signalez tout incident.",
        ],
      },
      {
        id: "cookies",
        heading: "7. Cookies",
        paragraphs: [
          "Nous utilisons des cookies de session essentiels à l'authentification. Aucun cookie publicitaire tiers.",
        ],
      },
      {
        id: "contact",
        heading: "8. Contact",
        paragraphs: [
          "Pour toute question : hey@solunary.health.",
        ],
      },
    ],
  },
};
